import {
  Flex,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Spinner,
  Text,
  Box,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Heading, Pagination, Table } from '~/components';
import { useAccessReportsById, useQueryParams } from '~/hooks';

export const AccessReportsDetails: React.VFC = () => {
  const { userId } = useParams<{ userId: string }>();
  const queryParams = useQueryParams();
  const login = queryParams.get('login');

  const [page, setPage] = useState(1);

  const { data, isLoading, error } = useAccessReportsById(userId, page);

  return (
    <Box px="8" py="4">
      <Heading hasBackButton>Relatórios de acessos</Heading>
      <Flex pt={2} flexDir="column" w="100%">
        {isLoading ? (
          <Flex justify="center">
            <Spinner />
          </Flex>
        ) : error ? (
          <Flex justify="center">
            <Text>Falha ao obter dados dos grupos.</Text>
          </Flex>
        ) : (
          <>
            <Table>
              <Thead>
                <Tr>
                  <Th>Usuário</Th>
                  <Th>Data/hora entrada</Th>
                  <Th>Data/hora saída</Th>
                  <Th>IP Usuário</Th>
                  <Th style={{ textAlign: 'left' }}>URL</Th>
                </Tr>
              </Thead>
              <Tbody>
                {data &&
                  data.results.map(access => (
                    <Tr key={access.id_registrourl}>
                      <Td>{login}</Td>
                      <Td>{access.formattedEntryDateTime || '-'}</Td>
                      <Td>{access.formattedDepartureDateTime || '-'}</Td>
                      <Td>{access.ip_remoto}</Td>
                      <Td style={{ textAlign: 'left' }}>{access.ds_url}</Td>
                    </Tr>
                  ))}
              </Tbody>
            </Table>
            <Flex justify="flex-end">
              <Pagination
                totalCountOfRegisters={data?.totalCount || 0}
                currentPage={page}
                onPageChange={setPage}
              />
            </Flex>
          </>
        )}
      </Flex>
    </Box>
  );
};
